<template>
  <div class="download-box">
    <img class="img-top" src="@/assets/img/mobile-img/download1.png" />
    <div class="img-btn">
      <img class="img-down" src="@/assets/img/mobile-img/download2.png" />
      <div class="button-box">
        <span class="button button-and" @click="toDownlode">Android 下载</span>
        <span class="button button-ios" @click="toDownlode">App Store下载</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Toast } from "vant";
export default {
  name: "download",
  data() {
    return {
      androidUrl: "",
    };
  },
  created() {
    this.getAndroidVersion();
  },
  methods: {
    async getAndroidVersion() {
      const res = await axios.get(
        `${
          process.env.NODE_ENV === "development" ? this.$global.url : ""
        }/zw-public/version/nf/getNewestVersion`,
        { headers: { deviceType: "android" } }
      );
      if (res.status === 200 && res.data.resultCode === "200") {
        this.androidUrl = res.data.data.upgradePath;
      } else {
        this.$Message.error("数据获取异常");
      }
    },
    // 推荐去下载app
    toDownlode() {
      var u = navigator.userAgent;
      var isWeixin = u.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      Toast({
        message: "正在下载...",
        duration: 2500,
      });
      // 微信内
      if (isWeixin) {
        window.location.href =
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.china.knowledgemesh";
      } else {
        if (isAndroid) {
          //安卓app的scheme协议
          window.location.href = "android://com.china.knowledgemesh/";
          // 下载地址
          window.location.href = this.androidUrl;
        } else if (isIOS) {
          //ios端下载地址
          window.location.href =
            "https://apps.apple.com/us/app/%E4%B8%AD%E6%96%87%E7%9F%A5%E8%AF%86%E7%BD%91/id1618139452";
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.download-box {
  position: relative;
  .img-top {
    width: 100%;
    height: 100%;
  }
  .img-btn {
    margin-top: -190px;
    position: relative;
    .img-down {
      width: 100%;
      height: 100%;
      // float: left;
      // background: url(~@/assets/img/mobile-img/download2.png) no-repeat;
      // background-size: cover;
      // text-align: center;
    }
    .button-box {
      position: absolute;
      top: 100px;
      left: 0;
      width: 100%;
      text-align: center;
      .button {
        display: inline-block;
        width: 128px;
        height: 49px;
        border-radius: 24px;
        font-size: 12px;
        color: #ffffff;
        line-height: 49px;
        text-align: center;
      }
      .button-ios {
        background: #4a79f1;
      }
      .button-and {
        background: #242a34;
      }
      & span:first-child {
        margin-right: 10px;
      }
    }
  }
}
</style>
